export default __webpack_public_path__ + "static/media/gourd_and_paper.5c2ef9bd.jpg";